<template>
  <div class="input-wrapper">
    <div
      :class="[
        'input-field',
        { active: focus },
        { 'filled-up': filledUp },
        { error: showError },
        { disabled: disabled }
      ]"
    >
      <label>{{ placeholder }}</label>
      <input
        ref="input"
        :type="type"
        :value="value"
        :disabled="disabled"
        :maxlength="maxLength"
        @paste="handlePaste"
        @input="setValue"
        @focus="toggleFocus"
        @blur="toggleFocus"
        @change="callback"
      >
      <span
        v-if="type === 'password'"
        :class="['toggle-password', showPassword ? 'hide' : 'show']"
        @click="togglePassword"
      />
    </div>
    <p
      v-if="errorMessage && showError"
      :class="['text-small', { error: showError }]"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="infoMessage"
      class="text-small"
    >
      {{ infoMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    type: {
      type: String,
      required: true,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Seleziona',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    paste: {
      type: Boolean,
      default: true,
    },
    regex: {
      type: Array,
      default: () => [],
    },
    infoMessage: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    maxLength: {
      type: Number,
      default: 250,
    },
  },
  data() {
    return {
      focus: false,
      filledUp: false,
      showError: false,
      errorMessage: null,
      showPassword: false,
    };
  },
  watch: {
    value(v) {
      this.isFilledUp(v);
    },
    showError(v) {
      this.$emit('error', v);
    },
  },
  mounted() {
    const { autoFocus, value } = this;
    this.filledUp = !!value;
    this.validate(value);
    if (autoFocus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    validate(v) {
      if (v) {
        const error = this.regex.find(el => !el.rule.test(v));
        if (error) {
          this.setError(true, error.msg);
        } else {
          this.setError(false, null);
        }
      }
    },
    setError(value, msg) {
      this.showError = value;
      this.errorMessage = msg;
    },
    isFilledUp(value) {
      this.filledUp = !!value;
    },
    setValue(event) {
      if (event.target.value) {
        this.validate(event.target.value);
        this.$emit('input', event.target.value);
      } else {
        this.$emit('input', null);
      }
    },
    toggleFocus() {
      this.focus = !this.focus;
    },
    callback() {
      this.$emit('callback', this.value);
    },
    handlePaste(event) {
      if (!this.paste) {
        event.preventDefault();
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
      this.$refs.input.type = this.showPassword ? 'text' : 'password';
    },
  },
};
</script>
